import { store } from '@/store';
import  router from '@/router';
import insurance from '@/utils/insurance';
import axios from '@/utils/axios';

const review = {
    /**
     * 打 API-CheckBeforeSave 要保前資料檢查
     * 
     * @public
     */
    checkBeforeSave() {
        return new Promise((resolve, reject) => {
            axios.post(apiUrl.CheckBeforeSave, {
                Policy: {
                    Estimate: store.getters['estimate/getData'],
                    Insures: insurance.setUploadInsurances(),
                    Hccs: store.state.hccs.data,
                    RenewPolicy: store.state.renewPolicy,
                    Provs: store.state.policy.provs,
                }
            }).then(res => {
                res.data.Code === 200 ? resolve(res.data.Data) : reject(res.data.ErrMessage);
            }).catch(err => {
                let text = err.response ? err.response.data.ErrMessage : null;
                if(!!text){
                    text = '<ul><li> ' + 
                        text.replace(/\|/g,'</li><li> ') 
                        + '</li></ul>';
                }
                reject(text);
            });
        });
    },
    /**
     * 打 API-Login 發送簡訊認證
     * 
     * @public
     */
    otp() {
        if (store.getters['otp/loginOtpCodeAvailable']) router.push(`/${router.currentRoute.value.params.type}/checkout/otp`);

        store.commit('showLoading');

        axios.post(apiUrl.Login, {
            'account': store.state.member.id,
            'birthday': store.state.auth.birthday,
            'sourceRemark': store.state.insCategory === 'Car' ? '汽車險' : '機車險'
        }).then(res => {

            if (res.data.code !== 200) {
                store.commit('setDialog', {
                    title: '填寫資料錯誤',
                    text: '您填入的資料有誤，請確認後重新輸入。<br>※若一直無法登入，請聯繫客服，確認您的個人資料。',
                    active: true
            });

                store.commit('closeLoading');

                return;
            }

            store.commit('otp/setLogin', {
                email: res.data.data.otpEmail,
                id: res.data.data.otpId,
                mobile: res.data.data.otpMobile,
                frontCode: res.data.data.otpFrontCode,
                expired: res.data.data.otpExpireTime,
                birthday: store.state.auth.birthday
            });

            router.push(`/${router.currentRoute.value.params.type}/checkout/otp`);

        }).catch(err => {
            store.commit('setDialog', {
                text: err.response.data.message,
                active: true
            });
            store.commit('closeLoading');
        });
    },
};

export default review;